<template lang="pug">
.pretty-picture(v-if="frameStore.show")
  each pp in ['m31', 'm42', 'm45', 'm101', 'perseus']
    v-tile-layer(:animationLod="Store.config.tileLayer.animationLod", :lodBias="Store.config.tileLayer.lodBias", :cacheSize="Store.config.tileLayer.cacheSize")
      TextureProvider(:params=`frameStore.params.${pp}`, src=`//hscmap.mtk.nao.ac.jp/data/pretty_picture/${pp}`)
</template>


<script lang="ts">
import Vue from 'vue'
import { TextureProviderComponent } from "./TextureProviderComponent";
export default Vue.extend({
  components: {
    TextureProvider: TextureProviderComponent,
  },
  props: {
    frameStore: { required: true },
  },
})
</script>